<template>
  <div class="cat-assignment">
    <CatTutorial v-if="isTutorialChecked" />
    <NavigationBar />

    <div class="assignment-header">
      <div class="cl-container title">{{ $t('common.class_assignment') }}</div>
    </div>

    <div class="row assignment-container">
      <div class="col-lg-5 col-md-12 col-xs-12 px-6">
        <div class="cl-card row assignment-class-filter">
          <b-dropdown :text="selectedClassName" variant="variant" >
            <b-dropdown-item v-for="item in filterClasses" :key="item.id"
              @click="selectClass(item)">
              {{ item.name }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="row assignment-stats-score" v-if="selectedClassId !== 0">
          <div class="col-6 user-score">
            {{ $t('assignment.user_score') }} <strong>&nbsp;&nbsp;&nbsp;&nbsp;{{ userScore || 0 }}{{ $t('common.score_value') }}</strong>
          </div>
          <div class="col-6 class-score">
            {{ $t('assignment.class_average_score') }} <strong>&nbsp;&nbsp;{{ classScore || 0 }}{{ $t('common.score_value') }}
          </strong></div>
        </div>
        <div class="cl-card assignment-stats-filter row">
          <div class="col-3 assignment-stats" v-for=" item in filterAssignmentStats" :key="item.code"
            :class="{ 'active' : selectedStats === item.code }"
            @click="selectStats(item.code)">
            <div class="assignment-count">{{ item.value || 0 }}</div>
            <div class="assignment-name">{{ item.name }}</div>
          </div>
        </div>
      </div>

      <div class="col-lg-7 col-md-12 col-xs-12 px-6">
        <template v-if="busy">
          <div :style="{ 'padding': '24px' }">
            <LoadingBounce></LoadingBounce>
          </div>
        </template>
        <template v-else>
          <template v-if="isFilterAssignments">
            <Assignment 
              :eventLabel="'assignment'"
              :assignments="filterAssignments"
              :isBlock="true" />
            <InfiniteLoading v-if="filterAssignments.length >= 10" @infinite="infiniteHandler" class="w-100">
              <div slot="spinner">
                <LoadingBounce></LoadingBounce>
              </div>
              <span slot="no-results"></span>
              <span slot="no-more"></span>
            </InfiniteLoading>
          </template>
          <template v-else>
            <div class="empty-assignment">
              <img src="/static/images/img_empty_assignment.png" alt="empty-assignment">
              <div class="title">{{ $t('common.empty_assignment') }}</div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';

  import Assignment from '../../cat-main/components/Assignment';
  import CatTutorial from '../../cat-main/components/CatTutorial';

  export default {
    name: 'cat-assignment',

    data() {
      return {
        selectedStats: 'all',
        page: 1,
        limit: 10,
        selectedClassName: this.$t('assignment.all_class'),
        busy: false,
      };
    },

    components: {
      Assignment,
      InfiniteLoading,
      CatTutorial,
    },

    computed: {
      ...mapGetters({
        assignmentStats: 'getAssignmentStats',
        assignments: 'getAssignments',
        userId: 'currentUserId',
        selectedClassId: 'getSelectedClassId',
        classes: 'getClasses',
        assignmentPosition: 'getAssignmentPosition',
        checkedTutorials: 'checkedTutorials',
      }),

      isTutorialChecked() {
        return !this.checkedTutorials.learningIntro;
      },

      filterClasses() {
        return [
          {
            name: this.$t('assignment.all_class'),
            id: 0,
          },
          ...this.classes,
        ];
      },

      filterAssignments() {
        return this.assignments && this.assignments[this.selectedStats];
      },

      filterAssignmentPosition() {
        return this.assignmentPosition && this.assignmentPosition[this.selectedStats];
      },

      isFilterAssignments() {
        return this.filterAssignments && this.filterAssignments.length > 0;
      },

      userScore() {
        return this.assignmentStats && this.assignmentStats.user_score;
      },

      classScore() {
        return this.assignmentStats && this.assignmentStats.class_score;
      },

      totalCount() {
        return this.assignmentStats && this.assignmentStats.total_count;
      },

      todoCount() {
        return this.assignmentStats && this.assignmentStats.todo_count;
      },

      inReviewCount() {
        return this.assignmentStats && this.assignmentStats.in_review_count;
      },

      endedCount() {
        return this.assignmentStats && this.assignmentStats.ended_count;
      },

      filterAssignmentStats() {
        return [
          {
            name: this.$t('assignment.stats.total_count'),
            code: 'all',
            value: this.totalCount,
          },
          {
            name: this.$t('assignment.stats.todo_count'),
            code: 'todo',
            value: this.todoCount,
          },
          {
            name: this.$t('assignment.stats.in_review_count'),
            code: 'in_review',
            value: this.inReviewCount,
          },
          {
            name: this.$t('assignment.stats.ended_count'),
            code: 'ended',
            value: this.endedCount,
          },
        ];
      },

    },

    methods: {
      ...mapActions([
        'fetchActiveAssignments',
        'fetchAssignmentStats',
        'fetchFilterAssignments',
        'fetchClasses',
        'setClassId',
        'fetchFilterAssignmentStats',
        'resetAssignments',
      ]),

      selectClass(classes) {
        this.$ga.event({
          eventCategory: 'assignments',
          eventAction: 'click.class_filter',
          eventLabel: classes.id,
        });

        this.selectedClassName = classes.name;
        this.setClassId(classes.id);
      },

      selectStats(code) {
        this.$ga.event({
          eventCategory: 'assignments',
          eventAction: 'click.stats_filter',
          eventLabel: code,
        });

        this.selectedStats = code;
      },

      infiniteHandler($state) {
        const filters = {};
        filters.page = this.filterAssignmentPosition;
        filters.per_page = this.limit;
        filters.status = this.selectedStats;
        if (this.selectedClassId !== 0) {
          filters.class_id = this.selectedClassId;
        }

        this.fetchFilterAssignments(filters)
          .then((data) => {
            if (data.length > 0) {
              $state.loaded();
            } else {
              $state.complete();
            }
          });
      },
    },

    beforeMount() {
      this.$route.meta.title = this.$t('common.class_assignment');
      this.resetAssignments();
      this.busy = true;
      const filters = {};
      filters.page = this.page;
      filters.per_page = this.limit;
      filters.status = this.selectedStats;
      this.fetchClasses(this.userId)
        .then(() => (
          this.fetchAssignmentStats()
        ))
        .then(() => (
          this.fetchFilterAssignments(filters)
        ))
        .then(() => {
          this.busy = false;
        });
    },

    watch: {
      selectedStats(selected) {
        if (!this.assignments[selected]) {
          this.busy = true;
          const filters = {};
          filters.page = this.page;
          filters.per_page = this.limit;
          filters.status = selected;

          Promise.resolve()
            .then(() => {
              if (this.selectedClassId !== 0) {
                filters.class_id = this.selectedClassId;
              }
              return this.fetchFilterAssignments(filters);
            })
            .then(() => {
              this.busy = false;
            });
        }
      },

      selectedClassId(selected) {
        if (!this.assignments) {
          this.busy = true;
          const filters = {};
          filters.page = this.page;
          filters.per_page = this.limit;
          filters.status = this.selectedStats;
          filters.class_id = selected;

          this.fetchFilterAssignments(filters)
            .then(() => (
              this.fetchFilterAssignmentStats(selected)
            ))
            .then(() => {
              this.busy = false;
            });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .cat-assignment {

    .assignment-header {
      height: 100px;
      width: 100%;
      background-color: #ffffff;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
      padding: 24px;

        .title {
          font-size: 20px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.54);
          padding: 0px 14px 0px 14px;
        }
    }

    .assignment-container {
      max-width: 946px;
      margin: 0 auto;

      .assignment-class-filter {
        background-color: #ffffff;
        padding: 6px;
        margin-top: 12px;
        margin-bottom: 8px;
        margin-right: 2px;
        margin-left: 2px;

        .assignment-dropdown {
          display: none;
          top: 65px;
          z-index: 2;
          left: 0;
          right: 0;
          width: 100%;
          position: absolute;
          padding: 14px;
          margin: 4px 0px 4px 0px;
        }
      }

      .assignment-stats-score {
        padding: 14px 6px 44px 6px;

        .user-score {
          font-size: 14px;
          color: #939393;

          strong {
            color: #000000;
          }
        }

        .class-score {
          font-size: 14px;
          color: #939393;

          strong {
            color: #000000;
          }
        }
      }

      .assignment-stats-filter {
        margin-right: 2px;
        margin-left: 2px;

        .assignment-stats {
          padding: 18px;
          color: #000000;
          cursor: pointer;
  
          &.active {
            color: #00c896;
            font-weight: bold;
            border-bottom: 4px solid #00c896;
          }
  
          .assignment-count {
            font-size: 22px;
            font-weight: bold;
          }
  
          .assignment-name {
            font-size: 14px;
          }
        }
      }

      .empty-assignment {
        width: 128px;
        margin: 0 auto;

        img {
          width: 100px;
          height: 100px;
          margin: 14px;
        }

        .title {
          margin: 14px 0px 14px 0;
          color: #979797;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// CatAssignment.vue?544d4864